import RadioGroupItem from './RadioGroupItem'
import RadioGroupRoot from './RadioGroupRoot'

export const RadioGroup = {
  Root: RadioGroupRoot,
  Item: RadioGroupItem
}
